import { useQuery } from 'react-query';
import { Collection } from '../api';

export function useVoivodeships() {
  const { data } = useQuery('voivodeships', Collection.voivodeships);

  return data;
}
